import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Gauge from "./guage";
import {
  startStop,
  updateUI as updateUIFromModule,
  startUpdateLoop,
  stopUpdateLoop,
} from "../../utils/s1.js";

import AuthContext from "../../components/auth-context";
import SpeedTestApi from "../../api/speed-test";

interface Results {
  download: number;
  upload: number;
  ping: number;
  jitter: number;
}

export default function SpeedTest() {
  const [isRunning, setIsRunning] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [ip, setIp] = useState<string | undefined>();
  const [results, setResults] = useState<Results>({
    download: 0,
    upload: 0,
    ping: 0,
    jitter: 0,
  });
  const context = useContext(AuthContext);
  const { activeFileId } = context;
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    const fetchIp = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        if (isMounted) {
          setIp(data.ip);
        }
      } catch (error) {
        console.error("Error fetching the IP address:", error);
      }
    };

    fetchIp();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!isFinished) handleStartStop();

    const updateResults = (newResults: Results) => {
      setResults(newResults);

      if (
        newResults.download > 0 &&
        newResults.upload > 0 &&
        newResults.ping > 0 &&
        newResults.jitter > 0
      ) {
        stopUpdateLoop();
        setIsFinished(true);
      }
    };

    startUpdateLoop(updateResults);

    return () => {
      stopUpdateLoop();
    };
  }, []);

  const handleSubmit = () => {
    stopUpdateLoop();
    setIsFinished(true);

    let payload = {
      download: results.download,
      upload: results.upload,
      ping: results.ping,
      jitter: results.jitter,
      id: activeFileId,
      ip: ip,
    };

    const speedTestResult = new SpeedTestApi(context);
    speedTestResult.post(payload).then((result) => {
      console.log(result);
      navigate("/speedTest/result");
    });
  };

  const handleStartStop = () => {
    setIsRunning((prev) => !prev);
    startStop();
  };

  return (
    <div className="flex flex-col items-center gap-6">
      {isFinished && (
        <button
          onClick={handleSubmit}
          className="btn bgc-white  d-lg-inline-block btn-light-secondary mx-0"
        >
          ذخیره نتیجه
        </button>
      )}

      <div className="text-xl font-semibold text-center mb-2 text-orange-500"></div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-10 sm:gap-8">
        <div className="flex flex-col items-center">
          <Gauge
            key={`gauge-download-${results.download}`}
            id="gauge-ps"
            label="سرعت دانلود"
            value={results.download}
            width={300}
            height={320}
          />
          <div id="dlText" className="text-center text-lg mt-2 hidden">
            {/* {results.download === 0 ? "..." : `${results.download} Mbps`} */}
          </div>
        </div>
        <div className="flex flex-col items-center">
          <Gauge
            key={`gauge-upload-${results.upload}`}
            id="gauge-Up"
            label="سرعت آپلود"
            value={results.upload}
            width={300}
            height={320}
          />
          <div id="ulText" className="text-center text-lg mt-2 hidden">
            {/* {results.upload === 0 ? "..." : `${results.upload} Mbps`} */}
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-8 mt-6 sm:gap-10">
        <div className="flex flex-col items-center">
          <Gauge
            key={`gauge-ping-${results.ping}`}
            id="gauge-Ping"
            label="تاخیر (Ping)"
            units="ms"
            maxValue={10}
            majorStep={1}
            value={results.ping}
            width={180}
            height={180}
          />
          <div id="pingText" className="text-center text-sm mt-2 hidden">
            {/* {results.ping === 0 ? "..." : `${results.ping} ms`} */}
          </div>
        </div>

        <div className="flex flex-col items-center">
          <Gauge
            key={`gauge-jitter-${results.jitter}`}
            id="gauge-Jit"
            label="اعوجاج (Jitter)"
            units="ms"
            maxValue={10}
            majorStep={1}
            value={results.jitter}
            width={180}
            height={180}
          />
          <div id="jitText" className="text-center text-sm mt-2 hidden">
            {/* {results.jitter === 0 ? "..." : `${results.jitter} ms`} */}
          </div>
        </div>
      </div>
    </div>
  );
}
